import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { cloneDeep } from 'lodash-es'
import { Row, Panel, Message, IconButton, Icon, Placeholder } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import CustomIconMessageInfo from '../../../widgets/CustomIconMessageInfo'
import ExpectedResultWidgets from './ExpectedResultWidgets'
import ExpectedWayWidgets from './ExpectedWayWidgets'
import WarningMessage from '../../../components/message/WarningMessage/WarningMessage'
import CustomAlertMessageInfo from '../../CustomAlertMessageInfo'

export default function ExpectedResultView(props) {
  const { Paragraph } = Placeholder
  const { showCommandButton, schema, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  // const [isEdit, setIsEdit] = useState(false)
  const [canEdit, setCanEdit] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)

  const dispatch = useDispatch()

  // useEffect(() => {
  //   setIsEdit(isEditAll)
  //   setCanEdit(isEditAll)
  //   setIsError(false)
  // }, [isEditAll])

  console.log(formSchema)

  return (
    <>
      {formSchema && (
        <Panel
          className="proposal-expected-result-widget"
          shaded
          header={formSchema.header}
          eventKey={2}
          shaded
          collapsible
          defaultExpanded
          ref={(section) => {
            setSection(section)
          }}
        >
          <div className="proposal-expected-result-content">
            <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

            {formSchema.description && (
              <Row style={{ marginBottom: 10 }}>
                <CustomAlertMessageInfo contents={schema.description} />
              </Row>
            )}

            {/* {formSchema.description && (
              <Row style={{ marginBottom: 10 }}>
                <CustomIconMessageInfo content={formSchema.description} />
              </Row>
            )} */}

            {formSchema.message && (
              <Row style={{ marginBottom: 10 }}>
                <Message showIcon type="info" description={formSchema.message} />
              </Row>
            )}

            <Row style={{ marginBottom: 10 }}>
              <ExpectedResultWidgets
                showCommandButton={showCommandButton}
                isEditAll={isEdit}
                schema={formSchema.expectedResult}
              />
            </Row>

            <Row style={{ marginBottom: 10 }}>
              <ExpectedWayWidgets
                showCommandButton={showCommandButton}
                isEditAll={isEdit}
                schema={formSchema.expectedWay}
              />
            </Row>

            {showCommandButton && (
              <>
                <hr />
                {isEdit ? (
                  <div>
                    <IconButton
                      appearance="ghost"
                      className="rs-btn-ghost-info"
                      icon={<Icon className="bt-gost-icon-radius-info" icon="backward" />}
                      onClick={(e) => {
                        onChangeIsEdit(false)
                        setIsError(false)
                        setIsDeleteError(false)
                        scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
                      }}
                      disabled={isLoading}
                    >
                      {'ดูรายการ' + (formSchema.buttonText ? formSchema.buttonText : '')}
                    </IconButton>
                  </div>
                ) : (
                  <IconButton
                    appearance="ghost"
                    className="rs-btn-ghost-edit"
                    onClick={() => {
                      onChangeIsEdit(true)
                      setIsError(false)
                      setIsDeleteError(false)
                      scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
                    }}
                    icon={<Icon className="bt-gost-icon-radius-edit" icon="edit" />}
                    disabled={isLoading}
                  >
                    {'เพิ่ม/แก้ไข' + (formSchema.buttonText ? formSchema.buttonText : '')}
                  </IconButton>
                )}
              </>
            )}
          </div>
        </Panel>
      )}
    </>
  )
}
